import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { APIURL, APIURLCOT } from "../../../Config";
import { toast } from "react-toastify";
import { DownloadTableExcel } from "react-export-table-to-excel";
import demoExcel from "../../../image/DemoStaff.xlsx";

function SalarytapAccountAdmin() {
  const emailid = localStorage.getItem("emailId");
  const token = localStorage.getItem("token");
  const fileInputRef = useRef(null);

  const email = localStorage.getItem("emailId");

  const workspaceid = localStorage.getItem("workspace");

  const [isLoader, setIsLoader] = useState(false);
  const [addAdmin, setAddAdmin] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(0);
  const [listAdmin, setListAdmin] = useState([]);
  const [activeTab, setActiveTab] = useState("home");
  const [addCAAdmin, setCAAddAdmin] = useState(false);
  const [CAopenAdmin, setCAOpenAdmin] = useState(0);
  const [listCAAdmin, setListCAAdmin] = useState([]);
  const [addFinanceAdmin, setFinanceAddAdmin] = useState(false);
  const [financeopenAdmin, setFinanceOpenAdmin] = useState(0);
  const [listFinanceAdmin, setListFinanceAdmin] = useState([]);
  const tableSalarytapAccountAdmin = React.useRef(null);
  const tableCreditAppraisalAdmin = React.useRef(null);
  const tableFinanciarAdmin = React.useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    if (activeTab === "home") {
      getAccountList();
    }
    if (activeTab === "profile") {
      getCAAccountList();
    }
    if (activeTab === "contact") {
      getFinanceAccountList();
    }
  }, [activeTab]);
  const LoginSchema = Yup.object().shape({
    file: Yup.mixed().required("A file is required"),
  });

  const Schema = Yup.object().shape({
    name: Yup.string().required("required"),
    mobile: Yup.string()
      .required("Required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    status: Yup.string().required("Please select an option"),
  });

  const openAddAdmin = (value) => {
    setAddAdmin(true);
    setOpenAdmin(value);
  };
  const getAccountList = () => {
    const data = { type: "Account_Admin", email: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/listadmin`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setListAdmin(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const openCAAddAdmin = (value) => {
    setCAAddAdmin(true);
    setCAOpenAdmin(value);
  };
  const getCAAccountList = () => {
    const data = { type: "CA_Admin", email: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/listadmin`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setListCAAdmin(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const openFinanceAddAdmin = (value) => {
    setFinanceAddAdmin(true);
    setFinanceOpenAdmin(value);
  };
  const getFinanceAccountList = () => {
    const data = { type: "Finance_Admin", email: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/listadmin`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        // setListFinanceAdmin(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link  tab-item ${
                activeTab === "owner" ? "active" : ""
              }`}
              id="owner-tab"
              data-bs-toggle="tab"
              data-bs-target="#owner"
              type="button"
              role="tab"
              aria-controls="owner"
              aria-selected={activeTab === "owner"}
              onClick={() => handleTabClick("owner")}
            >
              Owner
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link  tab-item ${
                activeTab === "home" ? "active" : ""
              }`}
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected={activeTab === "home"}
              onClick={() => handleTabClick("home")}
            >
              Salarytap Dashboard Admin
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link  tab-item ${
                activeTab === "profile" ? "active" : ""
              }`}
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "profile"}
              onClick={() => handleTabClick("profile")}
            >
              Credit Appraisal Admin
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link  tab-item ${
                activeTab === "contact" ? "active" : ""
              }`}
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact"
              type="button"
              role="tab"
              aria-controls="contact"
              aria-selected={activeTab === "contact"}
              onClick={() => handleTabClick("contact")}
            >
              APP Admin
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className={`tab-pane fade ${
              activeTab === "owner" ? "show active" : ""
            }`}
            id="owner"
            role="tabpanel"
            aria-labelledby="owner-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <h6>Email id: yogenkhosla@gmail.com</h6>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`tab-pane fade ${
              activeTab === "home" ? "show active" : ""
            }`}
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <div className="p-0 mb-3 d-flex align-items-center">
                    <div className="d-flex flex-grow-1">
                      <DownloadTableExcel
                        filename="SalarytapAccountAdmin"
                        sheet="users"
                        currentTableRef={tableSalarytapAccountAdmin.current}
                      >
                        <button
                          className="btn btn-success mb-3 mb-md-0"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          Download
                        </button>
                      </DownloadTableExcel>
                    </div>
                    <div>
                      {!addAdmin ? (
                        <button
                          className="btn btn-success mb-3 mb-md-0"
                          style={{ width: "120px", backgroundColor: "#66a725" }}
                          onClick={() => openAddAdmin(1)}
                        >
                          Add Admin
                        </button>
                      ) : (
                        <button
                          className="btn btn-secondary mb-3 mb-md-0"
                          style={{ width: "120px" }}
                          onClick={() => {
                            getAccountList();
                            setAddAdmin(false);
                          }}
                        >
                          Back
                        </button>
                      )}
                    </div>
                  </div>

                  {addAdmin ? (
                    <Formik
                      initialValues={{
                        email: listAdmin?.email || "",
                        name: listAdmin?.name || "",
                        mobile: listAdmin?.mobile || "",
                        status: listAdmin?.status || "Active",
                      }}
                      validationSchema={Schema}
                      onSubmit={(values, { resetForm }) => {
                        console.log("values", values);
                        if (openAdmin == 1) {
                          setIsLoader(true);
                          const data = {
                            ...values,
                            type: "Account_Admin",
                            ownerEmail: emailid,
                          };
                          axios
                            .request(`${APIURL}/addadmin`, {
                              method: "POST",
                              data: data,
                              headers: {
                                Authentication: token,

                                "Content-Type": "application/json",
                              },
                            })
                            .then((response) => {
                              console.log("response", response);
                              if (
                                response?.data?.message ===
                                "An Account already exists with this email Id. Please provide a new Email Id"
                              ) {
                                toast.warning(response?.data?.message);
                                setIsLoader(false);
                              } else {
                                toast.success(response?.data?.message);
                                setIsLoader(false);
                                getAccountList();
                                setAddAdmin(false);
                                resetForm();
                              }
                            })
                            .catch((error) => {
                              setIsLoader(false);
                              console.log(error);
                              resetForm();
                            });
                        }
                        if (openAdmin == 2) {
                          setIsLoader(true);
                          const data = {
                            ...values,
                            type: "Account_Admin",
                            ownerEmail: emailid,
                          };

                          axios
                            .request(`${APIURL}/updateadmin`, {
                              method: "POST",
                              data: data,
                              headers: {
                                Authentication: token,

                                "Content-Type": "application/json",
                              },
                            })
                            .then((response) => {
                              console.log("response", response);
                              setIsLoader(false);
                              getAccountList();
                              toast.success(response.data.message);
                              setAddAdmin(false);
                              resetForm();
                            })
                            .catch((error) => {
                              setIsLoader(false);
                              console.log(error);
                              resetForm();
                            });
                        }
                      }}
                    >
                      {({ touched, errors }) => (
                        <>
                          <Form className="">
                            <div>
                              <div>
                                <div className="">
                                  <label>Email*</label>
                                  <Field
                                    type="email"
                                    name="email"
                                    placeholder="Enter email"
                                    className={`form-control
                          ${touched.email && errors.email ? "is-invalid" : ""}`}
                                    disabled={openAdmin == 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="email"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mt-2">
                                  <label>Name*</label>
                                  <Field
                                    type="text"
                                    name="name"
                                    placeholder="Enter name"
                                    className={`form-control
                          ${touched.name && errors.name ? "is-invalid" : ""}`}
                                    disabled={openAdmin == 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="name"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>Mobile*</label>
                                  <Field
                                    type="text"
                                    name="mobile"
                                    placeholder="Enter mobile"
                                    className={`form-control
                          ${
                            touched.mobile && errors.mobile ? "is-invalid" : ""
                          }`}
                                    disabled={openAdmin == 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="mobile"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>Status*</label>
                                  <Field
                                    as="select"
                                    name="status"
                                    placeholder="Enter status"
                                    className={`form-control
                          ${
                            touched.status && errors.status ? "is-invalid" : ""
                          }`}
                                  >
                                    <option value="">Select..</option>
                                    <option value="Active">Active</option>
                                    <option value="Deactive">Deactive</option>
                                  </Field>
                                  <ErrorMessage
                                    component="div"
                                    name="status"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <button
                                  className="btn btn-success mt-3 border"
                                  type="submit"
                                  style={{ backgroundColor: "#66a725" }}
                                >
                                  {isLoader ? (
                                    <div
                                      className="spinner-border text-success"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </>
                      )}
                    </Formik>
                  ) : isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>Email</th>
                              <th style={{ textAlign: "center" }}>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(listAdmin)
                              ? listAdmin.map((item, i) => (
                                  <tr>
                                    <td style={{ width: "100px" }}>{i + 1}</td>
                                    <td>{item?.name}</td>
                                    <td>{item?.email}</td>
                                    <td style={{ width: "120px" }}>
                                      <div className="d-flex">
                                        <button
                                          style={{
                                            backgroundColor:
                                              item?.status === "Active"
                                                ? "#28a745"
                                                : "#f8f9fa",
                                            color:
                                              item?.status === "Active"
                                                ? "white"
                                                : "#6c757d",
                                            border: "1px solid #ced4da",
                                            padding: "0.375rem 0.75rem",
                                            borderRadius: "0.25rem",
                                            cursor:
                                              item?.status === "Active"
                                                ? "not-allowed"
                                                : "pointer",
                                            transition: "all 0.2s ease",
                                            marginRight: "0.5rem",
                                          }}
                                          onMouseOver={(e) => {
                                            if (item?.status !== "Active") {
                                              e.target.style.backgroundColor =
                                                "#28a745";
                                              e.target.style.color = "white";
                                            }
                                          }}
                                          onMouseOut={(e) => {
                                            if (item?.status !== "Active") {
                                              e.target.style.backgroundColor =
                                                "#f8f9fa";
                                              e.target.style.color = "#6c757d";
                                            }
                                          }}
                                          disabled={item?.status === "Active"}
                                          onClick={() => {
                                            if (item?.status !== "Active") {
                                              setListAdmin(item);
                                              setAddAdmin(true);
                                              setOpenAdmin(2);
                                            }
                                          }}
                                        >
                                          Active
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              item?.status === "Deactive"
                                                ? "#dc3545"
                                                : "#f8f9fa",
                                            color:
                                              item?.status === "Deactive"
                                                ? "white"
                                                : "#6c757d",
                                            border: "1px solid #ced4da",
                                            padding: "0.375rem 0.75rem",
                                            borderRadius: "0.25rem",
                                            cursor:
                                              item?.status === "Deactive"
                                                ? "not-allowed"
                                                : "pointer",
                                            transition: "all 0.2s ease",
                                          }}
                                          onMouseOver={(e) => {
                                            if (item?.status !== "Deactive") {
                                              e.target.style.backgroundColor =
                                                "#dc3545";
                                              e.target.style.color = "white";
                                            }
                                          }}
                                          onMouseOut={(e) => {
                                            if (item?.status !== "Deactive") {
                                              e.target.style.backgroundColor =
                                                "#f8f9fa";
                                              e.target.style.color = "#6c757d";
                                            }
                                          }}
                                          disabled={item?.status === "Deactive"}
                                          onClick={() => {
                                            if (item?.status !== "Deactive") {
                                              setListAdmin(item);
                                              setAddAdmin(true);
                                              setOpenAdmin(2);
                                            }
                                          }}
                                        >
                                          Deactive
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              : ""}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`tab-pane fade ${
              activeTab === "profile" ? "show active" : ""
            }`}
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <div className="p-0 mb-2 d-flex justify-content-end align-items-center">
                    <div className="d-flex flex-grow-1">
                      <DownloadTableExcel
                        filename="CreditAppraisalAdmin"
                        sheet="users"
                        currentTableRef={tableCreditAppraisalAdmin.current}
                      >
                        <button
                          className="btn btn-success mb-3 mb-md-0"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          Download
                        </button>
                      </DownloadTableExcel>
                    </div>
                    {!addCAAdmin ? (
                      <button
                        className="btn btn-success mb-3 mb-md-0"
                        style={{ width: "120px", backgroundColor: "#66a725" }}
                        onClick={() => {
                          openCAAddAdmin(1);
                        }}
                      >
                        Add Admin
                      </button>
                    ) : (
                      <button
                        className="btn btn-secondary mb-3 mb-md-0"
                        style={{ width: "120px" }}
                        onClick={() => {
                          getCAAccountList();
                          setCAAddAdmin(false);
                        }}
                      >
                        Back
                      </button>
                    )}
                  </div>
                  {addCAAdmin ? (
                    <Formik
                      initialValues={{
                        email: listCAAdmin?.email || "",
                        name: listCAAdmin?.name || "",
                        mobile: listCAAdmin?.name || "",
                        status: listCAAdmin?.status || "Active",
                      }}
                      validationSchema={Schema}
                      onSubmit={(values, { resetForm }) => {
                        console.log("values", values);
                        if (CAopenAdmin == 1) {
                          setIsLoader(true);
                          const data = {
                            ...values,
                            type: "CA_Admin",
                            ownerEmail: emailid,
                          };
                          axios
                            .request(`${APIURL}/addadmin`, {
                              method: "POST",
                              data: data,
                              headers: {
                                Authentication: token,

                                "Content-Type": "application/json",
                              },
                            })
                            .then((response) => {
                              console.log("response", response);
                              if (
                                response?.data?.message ===
                                "An Account already exists with this email Id. Please provide a new Email Id"
                              ) {
                                toast.warning(response?.data?.message);
                                setIsLoader(false);
                              } else {
                                toast.success(response?.data?.message);
                                setIsLoader(false);
                                getCAAccountList();
                                setCAAddAdmin(false);
                                resetForm();
                              }
                            })
                            .catch((error) => {
                              setIsLoader(false);
                              console.log(error);
                              resetForm();
                            });
                        }
                        if (CAopenAdmin == 2) {
                          setIsLoader(true);
                          const data = {
                            ...values,
                            type: "CA_Admin",
                            ownerEmail: emailid,
                          };
                          axios
                            .request(`${APIURL}/updateadmin`, {
                              method: "POST",
                              data: data,
                              headers: {
                                Authentication: token,

                                "Content-Type": "application/json",
                              },
                            })
                            .then((response) => {
                              console.log("response", response);
                              setIsLoader(false);
                              getCAAccountList();
                              toast.success(response?.data?.message);
                              setCAAddAdmin(false);
                              resetForm();
                            })
                            .catch((error) => {
                              setIsLoader(false);
                              console.log(error);
                              resetForm();
                            });
                        }
                      }}
                    >
                      {({ touched, errors }) => (
                        <>
                          <Form className="">
                            <div>
                              <div>
                                <div className="">
                                  <label>Email*</label>
                                  <Field
                                    type="email"
                                    name="email"
                                    placeholder="Enter email"
                                    className={`form-control
                          ${touched.email && errors.email ? "is-invalid" : ""}`}
                                    disabled={CAopenAdmin == 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="email"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mt-2">
                                  <label>Name*</label>
                                  <Field
                                    type="text"
                                    name="name"
                                    placeholder="Enter name"
                                    className={`form-control
                          ${touched.name && errors.name ? "is-invalid" : ""}`}
                                    disabled={CAopenAdmin == 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="name"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>Mobile*</label>
                                  <Field
                                    type="text"
                                    name="mobile"
                                    placeholder="Enter Mobile"
                                    className={`form-control
                          ${
                            touched.mobile && errors.mobile ? "is-invalid" : ""
                          }`}
                                    disabled={CAopenAdmin == 2}
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="mobile"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>Status*</label>
                                  <Field
                                    as="select"
                                    name="status"
                                    placeholder="Enter status"
                                    className={`form-control
                          ${
                            touched.status && errors.status ? "is-invalid" : ""
                          }`}
                                  >
                                    <option value="">Select..</option>
                                    <option value="Active">Active</option>
                                    <option value="Deactive">Deactive</option>
                                  </Field>
                                  <ErrorMessage
                                    component="div"
                                    name="status"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <button
                                  className="btn btn-success mt-3 border"
                                  type="submit"
                                  style={{ backgroundColor: "#66a725" }}
                                >
                                  {isLoader ? (
                                    <div
                                      className="spinner-border text-success"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </>
                      )}
                    </Formik>
                  ) : isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>Email</th>
                              <th style={{ textAlign: "center" }}>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(listCAAdmin)
                              ? listCAAdmin?.map((item, i) => (
                                  <tr>
                                    <td style={{ width: "100px" }}>{i + 1}</td>
                                    <td>{item?.name}</td>
                                    <td>{item?.email}</td>
                                    <td style={{ width: "120px" }}>
                                      <div className="d-flex">
                                        <button
                                          className={`btn ${
                                            item?.status === "Active"
                                              ? "btn-success"
                                              : "btn-outline-success"
                                          }`}
                                          disabled={item?.status === "Active"}
                                          onClick={() => {
                                            setListCAAdmin(item);
                                            setCAAddAdmin(true);
                                            setCAOpenAdmin(2);
                                          }}
                                        >
                                          Active
                                        </button>
                                        <button
                                          className={`btn ml-2 ${
                                            item?.status === "Deactive"
                                              ? "btn-danger"
                                              : "btn-outline-danger"
                                          }`}
                                          disabled={item?.status === "Deactive"}
                                          onClick={() => {
                                            setListCAAdmin(item);
                                            setCAAddAdmin(true);
                                            setCAOpenAdmin(2);
                                          }}
                                        >
                                          Deactive
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              : ""}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`tab-pane fade ${
              activeTab === "contact" ? "show active" : ""
            }`}
            id="contact"
            role="tabpanel"
            aria-labelledby="contact-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <Formik
                    initialValues={{
                      file: null,
                    }}
                    validationSchema={LoginSchema}
                    onSubmit={(values, { resetForm }) => {
                      const formData = new FormData();
                      formData.append("Files", values.file);
                      formData.append("emailid", email);
                      formData.append("ownerEmail", email);
                      formData.append("workspaceId", workspaceid);

                      // For debugging
                      for (let pair of formData.entries()) {
                        console.log(pair[0], pair[1]);
                      }

                      setIsLoader(true);
                      axios
                        .post(`${APIURLCOT}/staff/detailsupload`, formData, {
                          headers: {
                            Authorization: "Basic ODI3OTg0ODk5OTo1MDQ4",
                            "Content-Type": "multipart/form-data",
                          },
                        })
                        .then((response) => {
                          console.log("response::", response);
                          setIsLoader(false);
                          toast.success(
                            response?.data || "File uploaded successfully"
                          );
                          resetForm();
                          fileInputRef.current.value = null;
                        })
                        .catch((error) => {
                          console.log("error", error);
                          setIsLoader(false);
                          toast.error(
                            error.response?.data?.message ||
                              error.message ||
                              "An error occurred while uploading the file"
                          );
                          fileInputRef.current.value = null;
                          resetForm();
                        });
                    }}
                  >
                    {({ touched, errors, setFieldValue }) => (
                      <Form className="pt-4">
                        <div className="row" style={{ alignItems: "center" }}>
                          <div className="col-lg-9 col-md-9 col-sm-12">
                            <div className="form-group">
                              <label htmlFor="file">Upload File</label>
                              <input
                                id="file"
                                name="file"
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileInputRef}
                                className={`form-control ${
                                  touched.file && errors.file
                                    ? "is-invalid"
                                    : ""
                                }`}
                                onChange={(event) => {
                                  const file = event.currentTarget.files[0];
                                  setFieldValue("file", file);
                                }}
                              />
                              <ErrorMessage
                                name="file"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-12 d-flex justify-content-center">
                            <a
                              download="Demo.xlsx"
                              href={demoExcel}
                              style={{
                                width: "200px",
                                backgroundColor: "#6c757d",
                              }}
                              className="btn btn-secondary mt-3 ml-auto"
                            >
                              Download Demo File
                            </a>
                          </div>
                        </div>

                        <button
                          type="submit"
                          className="btn btn-success mt-3"
                          style={{ backgroundColor: "#66a725" }}
                          disabled={isLoader}
                        >
                          {isLoader ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{" "}
                              Uploading...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                        {isLoader && (
                          <div className="text-center mt-3">
                            <p>
                              Please be patient while we process your file and
                              update employee limits...
                            </p>
                          </div>
                        )}
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SalarytapAccountAdmin;
